// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2xOV_","notes":"Notes_notes__2EXRE"};